
export const setErrorProperty=(error,propName,value)=>{

Object.defineProperty(error,propName,{
value,
writable:true,
enumerable:false,
configurable:true
})
};